import { CurrentCostCenterAssignmentsDocument } from 'generated/resources/graphql'
import { orderBy } from 'lodash'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

interface Props {
  resourceId: number
}

const useCurrentCostCentersAssignments = ({ resourceId }: Props) => {
  const { company } = useCurrentSession()

  const { data, loading, refetch } = useQuery(CurrentCostCenterAssignmentsDocument, {
    variables: {
      companyId: company.id,
      resourceId,
      applyingOn: moment().format('YYYY-MM-DD'),
    },
  })

  const canSeeCostCenterMemberships =
    data?.employees.employee?._policies?.seeCostCenterMembershipsFor.can ?? false

  const canManageCostCenterMemberships =
    data?.employees.employee?._policies?.manageCostCenterMembershipsFor.can ?? false

  const hasCostCenters = (data?.finance.costCentersConnection?.totalCount || 0) > 0

  const assignments =
    orderBy(data?.finance.costCenterMembershipsConnection.nodes, 'startDate', 'desc') || []

  return {
    isLoading: loading,
    assignments,
    canSeeCostCenterMemberships,
    canManageCostCenterMemberships,
    hasCostCenters,
    refetch,
  }
}

export default useCurrentCostCentersAssignments
